import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";

export const CookiePolicy = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: false,
    });
  }, []);

  const colors = {
    background: "#ffffff",
    darkBackground: "#f1f1f1",
    textPrimary: "#1c1c1c",
    textSecondary: "#6b6b6b",
    accent: "#1c1c1c",
  };

  const containerStyle = {
    padding: "64px 16px",
    backgroundColor: colors.background,
    fontFamily: "Inter, system-ui, sans-serif",
  };

  const sectionStyle = (isDark) => ({
    backgroundColor: isDark ? colors.darkBackground : "#ffffff",
    borderRadius: "10px",
    padding: "48px 32px",
    marginBottom: "24px",
    boxShadow: "0px 2px 10px rgba(28,28,28,0.05)",
  });

  const headingStyle = {
    textAlign: "center",
    fontSize: "2.4rem",
    fontWeight: 700,
    color: colors.textPrimary,
    marginBottom: "32px",
  };

  const titleStyle = {
    fontSize: "1.3rem",
    fontWeight: 600,
    color: colors.textPrimary,
    marginBottom: "12px",
  };

  const textStyle = {
    color: colors.textSecondary,
    lineHeight: 1.7,
    fontSize: "1rem",
  };

  // const listStyle = {
  //   paddingLeft: "20px",
  //   marginBottom: "16px",
  // };

  return (
    <>
      <Helmet>
        <title>Cookie Policy | Biblivium</title>
        <meta
          name="description"
          content="Understand how Biblivium uses cookies and similar technologies to enhance your browsing experience."
        />
      </Helmet>

      <main style={containerStyle}>
        <div data-aos="zoom-in" data-aos-delay="100">
          <h1 style={headingStyle}>Cookie Policy</h1>

          <div style={sectionStyle(false)}>
            <p style={textStyle}>
              At <strong>Biblivium</strong>, we use cookies and similar technologies to support a smooth, thoughtful browsing experience. Cookies help us understand how readers engage with our platform, improve site functionality, and maintain a calm, reliable interface. This Cookie Policy explains what cookies are, how we use them, and the choices available to you.</p>
            <p style={textStyle}>
              This Cookie Policy explains what cookies are, how we use them, and your choices regarding them.
            </p>
          </div>

          <div style={sectionStyle(true)}>
            <h2 style={titleStyle}>1. What Are Cookies?</h2>
            <p style={textStyle}>
              Cookies are small text files stored on your device when you visit a website. They allow a site to recognize your browser, remember certain preferences, and gather information about how pages are accessed and used. Cookies do not typically contain personally identifiable information, but they help create a more consistent and efficient experience.</p>
          </div>

          <div style={sectionStyle(false)}>
            <h2 style={titleStyle}>2. Types of Cookies We Use</h2>
            <p style={textStyle}>
              We use essential cookies that are necessary for the basic operation of the website, including page navigation, secure access, and form submissions. Without these cookies, certain parts of the site may not function properly.</p>
            <p style={textStyle}>
              We also use performance and analytics cookies to understand how visitors move through the site, which pages are most visited, and how content is engaged with. This information helps us refine structure, improve clarity, and enhance usability.</p>
            <p style={textStyle}>
              Functional cookies may be used to remember preferences, such as language settings or display choices, so that your experience remains consistent across visits.</p>
          </div>

          <div style={sectionStyle(true)}>
            <h2 style={titleStyle}>3. Third-Party Cookies</h2>
            <p style={textStyle}>
              Some cookies may be placed by trusted third-party services that support the operation of Biblivium, such as analytics providers or technical infrastructure partners. These third parties process information according to their own privacy policies and are responsible for their respective data practices. We select services that align with responsible data protection standards.</p>
          </div>

          <div style={sectionStyle(false)}>
            <h2 style={titleStyle}>4. Your Cookie Choices</h2>
            <p style={textStyle}>
              You have control over how cookies are used on your device. Most web browsers allow you to manage, restrict, or disable cookies through their settings. You may also delete existing cookies at any time.</p>
            <p style={textStyle}>
              Please note that disabling certain cookies may affect website functionality and limit certain features. Even so, much of the site will remain accessible without them.</p>
          </div>

          <div style={sectionStyle(true)}>
            <h2 style={titleStyle}>5. Changes to This Policy</h2>
            <p style={textStyle}>
              We may update this Cookie Policy periodically to reflect changes in technology, regulations, or our operational practices. Any revisions will be published on this page with an updated effective date. Continued use of the website after updates indicates acceptance of the revised policy.</p>
          </div>

          <div style={sectionStyle(false)}>
            <h2 style={titleStyle}>6. Contact Us</h2>
            <p style={textStyle}>
              If you have questions about this Cookie Policy or how cookies are used on Biblivium, please contact us at <a href="mailto:info@lonewolfwrites.com" style={{ color: colors.accent }}>info@lonewolfwrites.com</a>. We are committed to providing clear and transparent information about your privacy.</p>
          </div>
        </div>
      </main>
    </>
  );
};
